import React from "react";
import { withRouter } from "react-router-dom";

class NotFoundPage extends React.Component {
  componentDidMount() {
    const auth = localStorage.getItem("auth");
    if (!auth) {
      this.props.history.replace("/login");
    }
  }

  render() {
    const auth = localStorage.getItem("auth");
    if (!auth) return null;

    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "70vh",
        textAlign: "center",
        color: "#1a1a2e",
      }}>
        <div style={{ fontSize: "4rem", marginBottom: "16px" }}>🔍</div>
        <h2 style={{ fontSize: "1.8rem", fontWeight: 700, marginBottom: "8px" }}>
          Page not found
        </h2>
        <p style={{ color: "#6b7280", fontSize: "1rem", marginBottom: "28px", maxWidth: "380px" }}>
          The page you're looking for doesn't exist or you don't have access to it.
        </p>
        <button
          onClick={() => this.props.history.push("/home")}
          style={{
            background: "#1a1a2e",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            padding: "10px 28px",
            fontSize: "0.95rem",
            cursor: "pointer",
          }}
        >
          Go to Home
        </button>
      </div>
    );
  }
}

export default withRouter(NotFoundPage);
